import axios from '@/services/ProductService/productInstance'


export default async function deletePricing(id: string) {
	try {
		const res = await axios.delete(`/pricing/${id}`)
		return res.data
	} catch {
		return null
	}
}

/*
pricing_used_in_product_profiles
pricing_used_in_products
pricing_not_found
 */